/* eslint-disable react/no-find-dom-node */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { modalOpen, modalType } from '../../redux/actions';
import PropTypes from 'prop-types';
import Group from '../Group';
import Button from '../Button';
import Text from '../Text';
import Image from '../Image';
import Lottie from '../LottieControl';
import { addNotification, dashboardListner, userDashboardListner, handleUserPermissions } from '../../firebase';
import theme, { rem } from '../../theme';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
`;

const StyledTextIntro = styled(Text)`
  margin-bottom: ${rem(20)};
`;

const StyledImage = styled(Image)`
  margin-bottom: ${rem(20)};
  width: 100%;
  height: ${rem(250)};
  object-fit: contain;
`;

const StyledText = styled(Text)`
  margin-bottom: ${rem(10)};
`;

const StyledContentWrapper = styled(Group)`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

const StyledButtonGroup = styled(Group)`
  margin-top: ${rem(20)};

  button {
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: ${rem(20)};
    width: ${rem(350)};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledMessage = styled(Text)`
  background: ${theme.color.dark[40]};
  padding: ${rem(8)} ${rem(10)};
  border-radius: ${rem(5)};
}
`;

const StyledLoading = styled(Lottie)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledGroup = styled(Group)`
  flex-direction: column;
  margin-bottom: ${rem(10)};

  &:last-child {
    margin-bottom: 0;
  }
`;

/** todo */
const removeRole = props => {
  const { activeDashboardId, id, role, closeModals } = props;

  //States
  const [loading, setLoading] = useState(true);
  const [roleData, setRoleData] = useState({});

  useEffect(() => {
    getData();
    document.getElementById('globalModal').firstElementChild.style.height =
      'auto';
    document.getElementById('globalModal').firstElementChild.style.width =
      '25rem';
  }, []);

  /** Get all the dashboard data */
  const getData = () => {
    dashboardListner
      .child(activeDashboardId)
      .child('roles')
      .child(role)
      .once('value', snapshot => {
        if (snapshot.val()) {
          setRoleData(snapshot.val());
          setLoading(false);
        }
      });
  };

  /** Handle remove */
  const handleRemove = () => {

    dashboardListner
      .child(activeDashboardId)
      .child('roles')
      .child(role)
      .remove()
      .then(() => {
        if (roleData.members) {
          Object.keys(roleData.members).map(member => {
            userDashboardListner
              .child(member)
              .child(activeDashboardId)
              .child('role')
              .child('type')
              .child(role)
              .remove()
              .then(() => {
                //HANDLE PERMISSIONS
                handleUserPermissions(activeDashboardId, member);
                addNotification(
                  member,
                  'userRoles',
                  activeDashboardId,
                  'Your role has been removed',
                  'success',
                  '/resources/friend.svg',
                  {},
                  'empty'
                );
              })
          });
        }
        closeModals();
      })
  };

  /** Return Chat messages */
  return loading ? (
    <StyledLoading animation="loading" animationWidth={400} />
  ) : (
    <StyledWrapper>
      <StyledContentWrapper fullwidth>
        <StyledText
          align="center"
          text="Remove role"
          textColor="#fff"
          textStyle="h3"
          tag="h1"
        />

        <StyledTextIntro
          align="center"
          text={`Are you sure you want to remove this ${role} role?`}
          textColor="#fff"
          textStyle="h6"
          tag="p"
        />

        <StyledButtonGroup fullwidth>
          <Button
            variant="contained"
            onClick={() => {
              handleRemove();
            }}
            bgColor={theme.color.success}
            text={{
              align: 'center',
              text: 'Remove role',
              textColor: '#fff',
            }}
          />
          <Button
            variant="contained"
            text={{
              align: 'center',
              text: 'Cancel',
              textColor: '#fff',
            }}
            onClick={() => {
              props.modalOpen(true);
              props.modalType(['updateRole', activeDashboardId, role, id]);
            }}
            bgColor={theme.color.cancel}
          />
        </StyledButtonGroup>
      </StyledContentWrapper>
    </StyledWrapper>
  );
};

removeRole.propTypes = {
  /** Chat Id */
  chatId: PropTypes.string,
  /** Message Id */
  messageId: PropTypes.string,
  /** Close function for the modal */
  closeModals: PropTypes.func,
};

removeRole.defaultProps = {
  chatId: null,
  messageId: null,
  closeModals: null,
};

export default connect(null, {
  modalType,
  modalOpen,
})(removeRole);
